<template>
  <div class="checkout-builder-text-modal py-3 px-6">
    <div class="d-flex justify-content-between align-items-center mb-6">
      <h3>Texto</h3>
      <button
        class="btn btn-sm py-3 px-4 btn-circle btn-new-secondary"
        @click="$emit('close')"
      >
        <i class="fa fa-close" />
      </button>
    </div>

    <bp-checkbox-group
      class="mb-5"
      v-model="form.config.display"
      :options="[
        { id: 'mobile', name: 'Versão para celular' },
        { id: 'desktop', name: 'Versão para computador' }
      ]"
    />

    <wysiwyg v-model="form.text" class="mb-5" ref="wysiwyg" />

    <div class="row mb-5">
      <div class="col-lg-6">
        <form-group
          v-model="form.config.color"
          color
          label="Cor do texto"
          id="background-color"
          placeholder="Ex.: #000000"
        />
      </div>
      <div class="col-lg-6">
        <form-group
          v-model="form.config['background-color']"
          color
          label="Cor do fundo"
          id="background-color"
          placeholder="Ex.: #000000"
        />
      </div>
    </div>

    <div class="d-flex flex-column flex-lg-row justify-content-end gap-5">
      <bp-button
        class="order-0 order-lg-1"
        label="Inserir Texto"
        @click="save"
        :disabled="!isValid"
      />
      <bp-button
        color="neutral"
        variant="filled-1"
        label="Cancelar"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ...formFields(["text", "config"], {
        ...this.data,
        config: {
          display: ["desktop", "mobile"],
          color: "#000",
          "background-color": "",
          ...this.data.config
        }
      })
    };
  },
  computed: {
    isValid() {
      return this.form.text;
    }
  },
  methods: {
    save() {
      this.$emit("save", { ...this.data, type: "text", ...this.form });
    }
  },
  mounted() {
    const linkInputs = document.querySelectorAll(
      ".vw-btn-link + .dashboard form input"
    );
    linkInputs.forEach(input => {
      input.addEventListener("click", () => {
        input.focus();
      });
    });
  }
};
</script>
<style lang="scss">
.checkout-builder-text-modal {
  .editr--content {
    background: #fff;
  }
}
</style>
